import { Component, OnInit } from '@angular/core';
import { ColumnType, ABCisTableModel } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-client-configuration',
  standalone: false,
  templateUrl: './client-configuration.component.html',
  styleUrls: ['./client-configuration.component.scss']
})
export class ClientConfigurationComponent implements OnInit {
  tableConfig: ABCisTableModel;



  constructor() { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'client-channel-job',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'clientId', header: 'Client ID', type: ColumnType.MultiSelectComplex, setUrl: 'client/lookup', isPrimary: true, isReadonly: true },
        { field: 'channelId', header: 'Channel ID', type: ColumnType.MultiSelectComplex, setUrl: 'channel/lookup', isPrimary: true, isReadonly: true },
        { field: 'jobId', header: 'Job ID', type: ColumnType.MultiSelectComplex, setUrl:  'job/lookup', isPrimary: true, isReadonly: true },
        { field: 'bufferSize', header: 'Buffer Size', type: ColumnType.String },
        { field: 'isRunning', header: 'isRunning', type: ColumnType.Boolean },
      ],
      isConfigurable: false
    };
  }
}
